import { UploadsService } from "~/entity/Uploads/api/service";

export const useUploads = () => {
  // POST
  const uploadDealerMetricFile = UploadsService.POST.uploadDealerMetrics;
  const acceptFile = UploadsService.POST.acceptFile;
  const rejectFile = UploadsService.POST.rejectFile;

  // GET
  const userToDealerTemplate = UploadsService.GET.userToDealerTemplate;

  return {
    // POST
    uploadDealerMetricFile,
    acceptFile,
    rejectFile,
    // GET
    userToDealerTemplate,
  };
};
